import { useEffect } from 'react';

/**
 * Reports changes to the dimensions of an Element's content or border box, or the bounding box of an SVGElement.
 * https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 */
function useResizeObserver(element, callback, {
  enabled = true,
  ...options
}) {
  useEffect(() => {
    if (!element || !enabled) return undefined;
    const observer = new ResizeObserver(callback);
    observer.observe(element, options);
    return () => observer.disconnect();
  }, [callback, enabled, ...Object.values(options).flat()]);
}

export { useResizeObserver as default };
